"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.applyFilter = exports.filter = void 0;

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _parseInt = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/number/parse-int"));

// this might be better using _.escapeRegExp by lodash. But good enough for now
function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

var filter = function filter(_ref) {
  var state = _ref.state,
      textSearchValue = _ref.textSearchValue;
  var options = state.options;
  var keys = (0, _keys["default"])(options);

  var isDivider = function isDivider(key) {
    var _ref2 = options[key].content.type.type || options[key].content.type,
        _ref2$displayName = _ref2.displayName,
        displayName = _ref2$displayName === void 0 ? null : _ref2$displayName;

    return displayName === "ListBox.Divider";
  };

  if (keys.length) {
    var filteredContent = keys.filter(function (key) {
      var hasLabel = typeof options[key].content === "string" || options[key].label || null;

      if (hasLabel) {
        if (isDivider(key)) {
          return true;
        }

        var label = options[key].content === "string" || options[key].label;
        var filterRegExp = new RegExp(escapeRegExp(textSearchValue), "gi");
        return label.match(filterRegExp);
      }

      return false;
    });
    var filteredOptions = filteredContent.filter(function (key, index) {
      var nextKey = filteredContent[index + 1];

      if (isDivider(key)) {
        if (!nextKey) {
          return false;
        }

        return !isDivider(nextKey);
      }

      return true;
    });

    if (!filteredOptions.length) {
      return [];
    }

    return filteredOptions.map(function (key) {
      return (0, _parseInt["default"])(key, 10);
    });
  }

  return [];
};

exports.filter = filter;

var applyFilter = function applyFilter(dispatch, type) {
  return function (filteredOptions, noResultsFound) {
    dispatch({
      type: type,
      payload: {
        filteredOptions: filteredOptions,
        noResultsFound: noResultsFound
      }
    });
  };
};

exports.applyFilter = applyFilter;
//# sourceMappingURL=helpers.js.map